import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { MODULES } from "./content";

export default function ModulesAccordion() {
  const [open, setOpen] = useState(0);

  return (
    <section className="bg-zinc-50 border-y border-zinc-200">
      <div className="max-w-3xl mx-auto px-6 py-24 md:py-32">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5 }}
        >
          <div className="overline-label text-zinc-400">Modules</div>
          <h2 className="font-display font-semibold text-h2 text-zinc-900 mt-4">
            Built around your day, from forecast to order.
          </h2>
        </motion.div>

        <div className="mt-12 divide-y divide-zinc-200 border-y border-zinc-200">
          {MODULES.map((m, i) => {
            const isOpen = open === i;
            return (
              <div key={m.name}>
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between gap-4 py-5 text-left group"
                >
                  <span className="flex items-center gap-4">
                    <m.icon className="h-5 w-5 text-zinc-400 group-hover:text-zinc-900 transition-colors" />
                    <span className="font-display font-medium text-zinc-900">{m.name}</span>
                  </span>
                  <Plus
                    className={`h-4 w-4 text-zinc-400 transition-transform duration-300 ${isOpen ? "rotate-45" : ""}`}
                  />
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3, ease: "easeInOut" }}
                      className="overflow-hidden"
                    >
                      <p className="pb-5 pl-9 text-sm text-zinc-500 leading-relaxed max-w-xl">{m.desc}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
